export default __webpack_public_path__ + "static/oeko-tex-responsible-business-95b3ad18c3cf1178d4e2c8e8a03cb75f.png";